<template>
    <div class="client-areas-filters">
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="4">
                        <app-form-select-input
                            placeholder="Sede"
                            :options="venueOptions"
                            v-model="venueId"
                        />
                    </b-col>
                    <b-col cols="12" md="4">
                        <app-form-text-input
                            placeholder="Nombre del área"
                            v-model="name"
                        />
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-btn variant="primary" @click="filter" class="btn-block">
                            <i class="fa fa-filter"></i> Filtrar
                        </b-btn>
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-btn variant="secondary" @click="clearFilters" class="btn-block">
                            <i class="fa fa-times-circle"></i> Limpiar
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue';
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue';
import SubTitle from '../../UI/Layout/SubTitle.vue';

export default {
    components: {
        appFormSelectInput: FormSelectInput,
        appFormTextInput: FormTextInput,
        appSubTitle: SubTitle
    },
    props: {
        venues: {
            type: Array,
            default: () => []
        },
        onFilter: {
            type: Function,
            required: true
        },
        onClearFilters: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            venueId: '',
            name: ''
        };
    },
    computed: {
        venueOptions() {
            return [
                ...this.venues
            ];
        }
    },
    methods: {
        filter() {
            const filters = {};
            if (this.venueId) {
                filters.venueId = this.venueId;
            }
            if (this.name) {
                filters.name = this.name;
            }
            this.onFilter(filters);
        },
        clearFilters() {
            this.venueId = '';
            this.name = '';
            this.onClearFilters();
        }
    }
};
</script>

